
const MODAL_HIDE = "MODAL_HIDE";
const MODAL_SHOW = "MODAL_SHOW";
const TEXT_TAG = "TEXT_TAG";

export default {
  namespaced: true,
  state: {
    show: false,
    content: "",
  },
  getters: {
    modalShow: state => state.show,
    text: state => state.content,
  },
  mutations: {
    [MODAL_HIDE] (state) {
      state.show = false;
    },
    [MODAL_SHOW] (state) {
      state.show = true;
    },
    [TEXT_TAG] (state, payload) {
      state.content = payload;
    }
  },
  actions: {
    show({ commit }, payload) {
      commit('TEXT_TAG', payload);
      commit('MODAL_SHOW');
    },
    hide({ commit }) {
      commit('MODAL_HIDE');
    }
  }
}
